import { render, staticRenderFns } from "./PlatformsSection.vue?vue&type=template&id=133bad0b"
import script from "./PlatformsSection.vue?vue&type=script&lang=js"
export * from "./PlatformsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports